/**
 * How-to-play ink icons (audit 2026-06-11).
 *
 * The landing's how-to-play card used platform emoji (✏️💬🏆) next to a
 * bespoke hand-drawn mark system, the one place the ink language broke into
 * stock glyphs. Three tiny stroke icons in the marks/v1 grammar instead.
 * The static scaffold in index.html carries matching inline copies, keep
 * the path data in sync (pinned by firstPaint.test.ts).
 */
type IconProps = { size?: number };

const STROKE = {
  "fill": "none",
  "stroke": "var(--ink)",
  "stroke-width": "1.8",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
} as const;

/** A stubby pencil, mid-stroke. */
export function PencilInk({ size = 20 }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
      <path {...STROKE} d="M6 18.2 16.4 7.4c1-1.1 3 .8 2 2L8.2 19.6l-3.4 1 .9-3.3" />
      <path {...STROKE} d="M15 9.2l2.2 2.1" />
    </svg>
  );
}

/** A loose speech bubble. */
export function SpeechInk({ size = 20 }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
      <path
        {...STROKE}
        d="M5 5.6C5.3 4.5 6.3 4 7.6 4h9c1.7 0 3 1.2 3 2.8v4.6c0 1.7-1.4 2.8-3.1 2.8H10l-3.8 3.4.5-3.5C5.4 13.8 4.6 13 4.6 11.4V6.8"
      />
    </svg>
  );
}

/** A wobbly trophy cup. */
export function TrophyInk({ size = 20 }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
      <path {...STROKE} d="M8 4.4h8.2v4c0 3-1.9 5.2-4.1 5.2S8 11.4 8 8.4z" />
      <path {...STROKE} d="M8 5.4c-2.6-.2-3.2 3.6.3 3.8M16.2 5.4c2.6-.2 3.2 3.6-.3 3.8" />
      <path {...STROKE} d="M12.1 13.8v2.8M9.2 19.4c1.8-.5 3.8-.5 5.7 0" />
    </svg>
  );
}
